import classNames from "classnames";
import React, { ComponentProps, forwardRef } from "react";
import { Button } from "../button";

import "./cta-button.css";

export const CtaButton = forwardRef<HTMLButtonElement, ComponentProps<"button">>(
	({ children, hidden, ...props }, ref) => {
		const styles = classNames("cta-button", {
			"cta-button--hidden": hidden,
		});

		return (
			<Button {...props} raised round ref={ref} className={styles}>
				{children}
			</Button>
		);
	},
);
CtaButton.displayName = "CtaButton";
